import React from "react";
import loading from "../../assets/spinning-loading.gif";
import ProgressBar from "@ramonak/react-progress-bar";

const StockLoadingLines = (props: {
  showLoadingLinesModal: boolean;
  showProgressBar: boolean;
  totalLines: number;
  fetchAmount: number;
  completedLines: number;
  stockCheckRef: string;
}) => {
  return (
    <>
      <div
        className={
          "finish-page " +
          (props.showLoadingLinesModal ? "modal-open" : "modal-closed")
        }
      >
        <div id="main-menu-modal-mask" className="modal-mask"></div>
        <div id="loading-lines-box" className="modal-page finish-page">
          <p id="finish-page-title">Loading Parts</p>
          <div className="info-page-section">
            Loading Parts for Stock Check: {Number(props.stockCheckRef)}
          </div>
          <div className="fetching-items-container-stock">
            <img
              src={loading}
              className="fetching-items-logo"
              alt="Loading"
            ></img>
          </div>
          {props.showProgressBar ? (
            <div id="stock-progress-bar">
              <ProgressBar
                completed={props.completedLines.toString()}
                maxCompleted={props.totalLines}
                baseBgColor="#575757"
                bgColor="#397cfc"
                isLabelVisible={false}
              />
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
};

export default StockLoadingLines;
